import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class formOrderstatus {
	static classname = 'form-orderstatus';

	constructor($orderstatus) {
		this.$orderstatus = $orderstatus;
		this.order_id_regexp = this.buildOrderIdRegexp();

		this.init();
	}

	get $form() {
		return this.$orderstatus.find('form');
	}

	get $button() {
		return this.$form.find('.form__btn');
	}

	set is_disabled_button(state) {
		this.$button.toggleClass('btn--disabled', state);
	}

	init() {
		const self = this;
		const $raw_value_input = self.$form.find('.s-plugin-orderstatus-order_id-input');
		const $submitted_value_input = self.$form.find('.s-plugin-orderstatus-order_id-input-submitted');

		$raw_value_input.data('label', 'Номер заказа');
		$raw_value_input.data('tip', 'Например: 100565');
		$raw_value_input.data('required', true);

		$raw_value_input.on('input', function () {
			const raw_value = $(this).val();
			self.is_disabled_button = self.order_id_regexp
				? !raw_value.match(/^[0-9]+$/) && !raw_value.match(self.order_id_regexp)
				: !raw_value.match(/^[0-9]+$/);

			const decoded_value = self.decodeOrderId(raw_value);
			$submitted_value_input.val(decoded_value || raw_value);
		});

		$raw_value_input.addClass('js-formgroup-decorator');

		self.is_disabled_button = true;
	}

	decodeOrderId(raw_order_id) {
		if (!this.order_id_regexp || !raw_order_id || !raw_order_id.match) {
			return null;
		}

		const match_result = raw_order_id.match(this.order_id_regexp);
		return match_result
			? match_result[1]
			: null;
	}

	buildOrderIdRegexp() {
		const order_pattern_parts = window.elkitorg_config.order_id_template.split('%ORDER_ID%');
		if (order_pattern_parts.length !== 2) {
			return null;
		}

		order_pattern_parts[0] = order_pattern_parts[0].replace(/([^0-9])/g, '$1?');
		order_pattern_parts[1] = order_pattern_parts[1].replace(/([^0-9])/g, '$1?');
		const pattern = `^${order_pattern_parts[0]}([0-9]+)${order_pattern_parts[1]}$`;

		return new RegExp(pattern);
	}
}
